module.exports = __webpack_public_path__ + "static/quad-img-2-4b837e5e1fdffe0208b557eddcc06223.jpg";